import styled from 'styled-components';
import { rem } from 'polished';

const StyledText = styled.p`
  font-size: ${rem('14px')};
  line-height: ${rem('22px')};
`;

export { StyledText };
